import Vue from "vue";
import Component from "vue-class-component";
import Axios from "axios";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "WhereToBuyDistributors" })
export default class WhereToBuyDistributors extends Vue {
    public localizer: any = Localizer;
    public vehicleTypes: any[] = [];
    public marketTypes: any[] = [];
    public countries: any[] = [];
    public geoMarkers: any[] = [];
    public showIntro: boolean = true;
    public showNotFound: boolean = false;
    public infoRequestUrl: string = null;
    public geoMarkerFilter: any = {
        vehicleType: null,
        marketType: null,
        country: null
    };

    get routes() {
        return (<any>window).App.routes;
    }

    public async created() {
        await this.getFilterData();
        await this.getGeoMarkers();
    }

    public async getFilterData() {
        let response = (await Axios.post(this.routes.WhereToBuy_GetDistributorFilterData)).data;
        if (response) {
            this.vehicleTypes = response.vehicleTypes;
            this.marketTypes = response.marketTypes;
            this.countries = response.countries;
            this.infoRequestUrl = response.infoRequestUrl;
        } else {
            this.vehicleTypes = [];
            this.marketTypes = [];
            this.countries = [];
            this.infoRequestUrl = null;
        }
    }

    public async getGeoMarkers() {
        if (this.geoMarkerFilter.vehicleType !== null && this.geoMarkerFilter.marketType !== null && this.geoMarkerFilter.country !== null) {
            let response = (await Axios.post(this.routes.WhereToBuy_GetDistributorGeoMarkers, this.geoMarkerFilter)).data;
            this.geoMarkers = response;
            this.showIntro = false;
            this.showNotFound = false;
            if (this.geoMarkers.length === 0) {
                this.showNotFound = true;
            }
        } else {
            this.geoMarkers = [];
            this.showIntro = true;
            this.showNotFound = false;
        }
    }

    public setGeoMarkerType() {
        this.geoMarkerFilter.marketType = null;
        this.getGeoMarkers();
    }
};